
import { useUnfurl } from '@/hooks/use-unfurl';
import { Skeleton } from '@/components/ui/skeleton';
import { Card } from '@/components/ui/card';
import { Link as LinkIcon } from 'lucide-react';

function LinkPreviewSkeleton() {
    return (
        <div className="flex gap-4">
            <Skeleton className="h-24 w-32 flex-shrink-0 rounded-md" />
            <div className="flex-grow space-y-2">
                <Skeleton className="h-5 w-3/4" />
                <Skeleton className="h-4 w-full" />
                <Skeleton className="h-4 w-5/6" />
                <Skeleton className="h-4 w-1/2 mt-2" />
            </div>
        </div>
    );
}

function LinkPreviewError({ url }: { url: string }) {
    return (
        <a href={url} target="_blank" rel="noopener noreferrer" className="text-primary underline hover:text-primary/90">
            {url}
        </a>
    )
}

export function LinkPreview({ url }: { url: string }) {
    const { data, isLoading, error } = useUnfurl(url);

    if (isLoading) {
        return <LinkPreviewSkeleton />;
    }
    
    if (error || !data) {
        return <LinkPreviewError url={url} />;
    }

    return (
        <a href={url} target="_blank" rel="noopener noreferrer" className="block not-prose no-underline text-foreground">
            <Card className="overflow-hidden transition-all hover:bg-muted/50">
                <div className="flex">
                    {data.imageUrl && (
                        <div className="relative h-32 w-40 flex-shrink-0 bg-muted">
                             <img
                                src={data.imageUrl}
                                alt={data.title}
                                className="h-full w-full object-cover"
                            />
                        </div>
                    )}
                    <div className="p-4 flex-grow">
                        <p className="font-bold text-base line-clamp-1">{data.title}</p>
                        <p className="text-sm text-muted-foreground line-clamp-2 mt-1">{data.description}</p>
                        <div className="flex items-center gap-2 mt-2 text-xs text-muted-foreground">
                            <LinkIcon className="h-3 w-3" />
                            <span>{data.domain}</span>
                        </div>
                    </div>
                </div>
            </Card>
        </a>
    )
}
